var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");
'use strict';$CLJS.EH=$CLJS.cj.g($CLJS.jj());